module.exports = __webpack_public_path__ + "img/crystalgold-third-bg.cb1f4092.jpg";